var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCall({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.034,
    height: 19.02,
    viewBox: "0 0 19.034 19.02",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "noun-call-5600861",
    d: "M123.4,52.679a2.117,2.117,0,0,0-2.6.31l-1.073,1.074a6.792,6.792,0,0,1-5.411-5.4l1.08-1.08a2.117,2.117,0,0,0,.31-2.6l-1.724-2.823a2.116,2.116,0,0,0-3.3-.394l-1.651,1.65a2.819,2.819,0,0,0-.769,2.563v0q2.422,11.567,14.128,14.121h0a2.816,2.816,0,0,0,2.58-.762c.479-.472,1.1-1.092,1.646-1.638a2.116,2.116,0,0,0-.394-3.3L123.4,52.679Z",
    transform: "translate(-108.199 -41.149)",
    fill: "#12d372",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCall);
export default __webpack_public_path__ + "static/media/call.760ba86bc52019aa578207de605c50d9.svg";
export { ForwardRef as ReactComponent };